/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SearchHeader from '../../components/searchHeader';
import DischargesTable from '../../components/customTables/admin/dischargesTable/DischargesTable';

import { RootState } from '../../redux/store';

/**
 * Style Imports
 */
import { DischargesContainer } from './styles/AdminViews.styles';

interface DischargeProps {
  searchTerm: string;
  selectedFacility: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const AdminDischarge: FC<DischargeProps> = ({
  searchTerm,
  selectedFacility,
  setSearchTerm
}) => {
  return (
    <DischargesContainer data-testid="admin-discharge">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <DischargesTable searchTerm={searchTerm} facilityId={selectedFacility} />
    </DischargesContainer>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    selectedFacility: state.AdminReducer.selectedFacility
  };
};

export default connect(mapReduxStateToProps)(AdminDischarge);
